import './Process.scss';
import {useRef, useState, useEffect} from 'react';
import {Stack, Container} from 'react-bootstrap';

function Process() {
    const containerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              // Optional: Disconnect observer if you only want to trigger it once
              // observer.unobserve(entry.target);
            } else {
              // Resets animation when user scrolls away
              setIsVisible(false); 
            }
          },
          { threshold: 0.2 } // Triggers when 20% of the section is visible
        );
    
        if (containerRef.current) {
          observer.observe(containerRef.current);
        }
    
        // Cleanup observer on unmount
        return () => {
          if (containerRef.current) {
            observer.unobserve(containerRef.current);
          }
        };
      }, []);
  return (
        <Stack gap={6} className="process">
            <h1>How We Build Your Product</h1>
            <Container ref={containerRef} className={`timeline-horizontal ${isVisible ? 'is-visible' : ''}`}>
                    <div className="step">
                        <div className="icon">💡</div>
                        <h4>Idea</h4>
                        <p>Understanding your business</p>
                    </div>

                    <div className="step active">
                        <div className="icon">🎨</div>
                        <h4>Design</h4>
                        <p>UI/UX &amp; planning</p>
                    </div>

                    <div className="step">
                        <div className="icon">⚙️</div>
                        <h4>Develop</h4>
                        <p>Build &amp; integrate</p>
                    </div>

                    <div className="step">
                        <div className="icon">🚀</div>
                        <h4>Launch</h4>
                        <p>Deploy &amp; scale</p>
                    </div>
            </Container>
        </Stack>
    );
}

export default Process;